<div class="c__section-container">
  <div class="c__section-title">
    <sd-html
      innerClass="is-body-s is-bold"
      [html]="title()"
    />
    <ng-content select="[section-title]" />
  </div>
  <button sd-button-icon
          [brand]="brand"
          type="button"
          class="c__toggle is-full-area"
          (click)="onClick()"
          [attr.aria-expanded]="isOpened()"
          [size]="IconSizeEnum.small"
          icon="icon-arrow-right"
  ></button>
</div>

@if (isOpened()) {
  <sd-modal-aside
    asideClass="c__section-modal-aside"
    [brand]="brand"
    [modalPositionInput]="PositionEnum.right"
    [(isOpened)]="isOpened"
    (isOpenedChange)="isOpenedChange.emit($event)"
    [backdrop]="true"
    [noPadding]="true"
  >
    <ng-container *ngTemplateOutlet="modalContent" />
  </sd-modal-aside>
} @else {
  <div class="is-hidden" data-testid="hidden">
    <ng-container *ngTemplateOutlet="modalContent" />
  </div>
}

<ng-template #modalContent>
  <ng-content select="[section-modal-content]" />
</ng-template>
